export default (axios, { email, promocode }) => axios.post('/registration/email-enter', { email, promocode });
